const Chip = ({ text }) => {
    return (
        <div className="flex items-center gap-2 rounded-2xl border-2 border-gray-200 bg-gray-50/50 py-0.5 px-1.5 text-sm">
            <span>{text}</span>
        </div>
    );
};

export default Chip;
